export const soilSampleType = (categoryFA) => {
    switch (categoryFA) {
        case 'آزمایش خاک':
            return 'خاک'
        case 'آزمایش آب':
            return 'آب'
        case 'آزمایش برگ':
            return 'برگ'
        default:
            break
    }
}

export const samplingDepthForTable = (sample) => {
    switch (sample) {
        case "۰ تا ۳۰ سانتی متر":
            return '0-30'
        case '۳۰ تا ۶۰ سانتی متر':
            return '30-60'
        case '۶۰ تا ۹۰ سانتی متر':
            return '60-90'
        default:
            break
    }
}

export const samplingDepth = (sampleLength) => {
    switch (sampleLength) {
        case 1:
            return '0-30'
        case 2:
            return '0-30, 30-60'
        case 3:
            return '60-90, 30-60, 0-30'
        default:
            return 'عمقی مشخص نشده است'
    }
}